import { LANDING_VARIANT_KEYS } from './landingVariantKeys.js';
/**
 * Resolve the landing-page variant from an incoming `utm_campaign` value.
 *
 * This is the single source of truth shared by three layers that must always agree:
 * - the CloudFront viewer-request function (UTM → which prerendered file to serve),
 * - the Nuxt prerender route enumeration (which variant files to generate),
 * - the client `LandingPage` (UTM → which content to render after hydration).
 *
 * Matching is case-insensitive so ad platforms can pass any casing. Unknown/empty campaigns resolve to
 * the default landing (`null`), never an error — the served file then falls back to `/{locale}`.
 *
 * Pure and CloudFront-function safe (no Vue/Node runtime, only ES the cloudfront-js-2.0 runtime supports).
 *
 * @__NO_SIDE_EFFECTS__
 */
export function resolveLandingVariant(utmCampaign) {
    if (!utmCampaign) {
        return null;
    }
    const normalized = utmCampaign.toLowerCase();
    for (const key of LANDING_VARIANT_KEYS) {
        if (key === normalized) {
            return key;
        }
    }
    return null;
}
//# sourceMappingURL=resolveLandingVariant.js.map